<div class="card">
    <div class="card-body">
      <h5 class="card-title">Bienvenido al Sistema Registro y Administración del Aula Virtual de Badminton</h5>
      <p class="card-text">Texto de bienvenida ....</p>
      <a href="javascript:void(0)" class="btn btn-badminton">Descargar manual de usuario</a>
    </div>
  </div>
 